export default () => ({
  root: {
    fontWeight: 300,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap'
  },
  selected: {
    fontWeight: 500
  },
  wrapper: {
    flexDirection: 'row'
  },
  img: {
    width: 30,
    height: 30,
    marginRight: 8
  },
  label: {
    display: 'inline-block',
    whiteSpace: 'nowrap'
  }
});
